export default __webpack_public_path__ + "static/image4-bb73c9728e747d9938a0b11de8977de7.webp";